export default function Spinner() {
  return (
    <div className='spinner-border mx-auto mt-5'>
      <span className="visually-hidden">Loading...</span>
    </div>
  )
}
